<div
  class="bg-white rounded-xl p-3 shadow-sm flex flex-col justify-between border border-gray-100 hover:shadow transition w-full h-full"
  [class.cursor-pointer]="clickable"
  [class.hover:bg-gray-50]="clickable"
  (click)="onCardClick()">

  <h3 class="text-sm font-medium text-gray-600 mb-1">
    {{ title }}
  </h3>

  <div class="text-2xl font-semibold text-gray-900 min-h-[32px] flex items-center">
    @if (loading) {
      <div class="skeleton-loader skeleton-value"></div>
    } @else {
      <span>{{ value }}</span>
    }
  </div>

  <div class="text-sm font-medium mt-1 min-h-[20px] flex items-center">
    @if (loading) {
      <div class="skeleton-loader skeleton-percentage"></div>
    } @else {
      <span [ngClass]="percentageColor">{{ percentage }}</span>
    }
  </div>
</div>
